import { css } from "@emotion/react";

export const styles = {
  card_qrcode: css`
    min-height: 258px;
    width: 203px;
    background-color: #ffffff;
    border-radius: 16px;
    align-self: center;
    align-items: center;
    word-break: break-word;
  `
};
